import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { trainingVideoService } from '@/services/trainingVideoService';

export const useTrainingVideos = (trainingId: string | number | undefined) => {
  return useQuery({
    queryKey: ['trainingVideos', trainingId],
    queryFn: () => trainingVideoService.list(trainingId!),
    enabled: !!trainingId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useUploadTrainingVideo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ trainingId, file }: { trainingId: string | number; file: File }) =>
      trainingVideoService.upload(trainingId, file),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['trainingVideos', variables.trainingId] });
      queryClient.invalidateQueries({ queryKey: ['training', variables.trainingId] });
    },
  });
};

export const useDeleteTrainingVideo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ trainingId, videoId }: { trainingId: string | number; videoId: string | number }) =>
      trainingVideoService.delete(trainingId, videoId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['trainingVideos', variables.trainingId] });
      queryClient.invalidateQueries({ queryKey: ['training', variables.trainingId] });
    },
  });
};

export const useReorderTrainingVideos = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ trainingId, videoIds }: { trainingId: string | number; videoIds: (string | number)[] }) =>
      trainingVideoService.reorder(trainingId, videoIds),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['trainingVideos', variables.trainingId] });
      queryClient.invalidateQueries({ queryKey: ['training', variables.trainingId] });
    },
  });
};
